import { NAV, BANNER, DASHBOARD } from "constants/types";

let initialState = {
  mobile: false,
  open: 0,
  bannerHeight: 0,
  subCategory: []
}

let Nav = (state = initialState, { type, payload }) => {
  switch(type) {

    case NAV.OPEN_NAV:
      if(typeof window !== undefined) {
        window.localStorage.setItem("nav", payload ? "1" : "0");
      }
      return {
        ...state,
        open: payload
      }

    case NAV.SUB_CATEGORY:

      return {
        ...state,
        subCategory: payload ? [payload] : []
      }

    case NAV.OPEN_MOBILE:

      return {
        ...state,
        mobile: payload
      }

    case BANNER.HEIGHT:

      return {
        ...state,
        bannerHeight: payload
      }

    default:
      return state
  }
}

export default Nav
